import {
  legacy_createStore as createStore,
  combineReducers,
  applyMiddleware,
  UnknownAction,
} from "redux";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { persistStore, persistReducer } from "redux-persist";
import { authReducer } from "./Login/State";

import { config } from "../config";

import { addBreadcrumb } from "../common/sentry";
import { reduxBroadcastMiddleware } from "./StoreBroadcast";
import * as Sentry from "@sentry/react-native";

const rootReducer = combineReducers({
  auth: persistReducer(
    {
      key: "auth-v1" + (config.production ? "" : config.name),
      version: 0,
      storage: AsyncStorage,
      throttle: 300,
      timeout: __DEV__ ? 5000 : 30000,
      blacklist: ["isRefreshingToken"],
      debug: !config.production,
      writeFailHandler(err) {
        Sentry.captureException(err);
      },
    },
    authReducer
  ),
});

export const store = createStore(
  rootReducer,
  applyMiddleware(
    (_store) => (next) => (action) => {
      addBreadcrumb({
        type: "redux",
        category: "redux.action",
        data: { actionType: (action as UnknownAction)?.type },
      });
      return next(action);
    },
    reduxBroadcastMiddleware()
  )
);

export const persistor = persistStore(store);

export async function waitUntilPersisted() {
  return persistor.flush();
}
